import React from "react";

const CategoryDropdownRoles = ({ selectHandler, elValue}) => {
  const L2List =  ["USER", "ADMIN", "TEACHER"];
  
  return (
    
    <select value={elValue} 
    name="ROLE" 
    id="ROLE" 
    className="min-w-[12rem] px-3 py-2 text-sm font-semibold"
    onChange={selectHandler}
>


{L2List.map(
    (les,i) => 
        {
            return (
                <option value={les} key={les}>
                    {les}
                </option>
            );
        }
    )
}           
</select>
    
    
    
    
    
   
  );
};


export default CategoryDropdownRoles;
